import React, { Component } from 'react';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <div className="root">{this.props.children || 'loading...'}</div>;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js